import { useId, useState } from 'react';
import Banner from '../../ui/Banner/Banner';
import { TextButton } from '../../ui/Button/Buttons';

type Ll144QuestionCardProps = {
  title: string;
  description?: string;
  hint?: string;
  definitions?: string[];
  children: React.ReactNode;
  className?: string;
};

export function Ll144QuestionCard({
  title,
  description,
  hint,
  definitions = [],
  children,
  className
}: Ll144QuestionCardProps) {
  const [showDefinitions, setShowDefinitions] = useState(false);
  const descriptionId = useId();
  const hintId = useId();
  const describedBy = [
    description ? descriptionId : undefined,
    hint ? hintId : undefined
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <fieldset
      className={`min-w-0 flex flex-col items-start gap-4 p-4 border border-gray-100 rounded-lg ${className ?? ''}`}
      aria-describedby={describedBy || undefined}
    >
      <legend className="text-zinc-900 font-medium text-left">
        {title}
      </legend>

      {description && (
        <p
          id={descriptionId}
          className="text-sm leading-5 text-gray-550 text-left"
        >
          {description}
        </p>
      )}

      {children}

      {hint && (
        <div id={hintId} className="w-full">
          <Banner
            text={hint}
            backgroundColorClass="bg-blue-50"
            titleColorClass="text-purple-900"
            textColorClass="text-purple-900"
            className="w-full"
          />
        </div>
      )}

      {definitions.length > 0 && (
        <div className="flex flex-col gap-4 items-start">
          <TextButton
            onClick={() => setShowDefinitions((visible) => !visible)}
            className="text-xs"
          >
            {showDefinitions ? 'Hide Definitions' : 'Show Definitions'}
          </TextButton>
          {showDefinitions && (
            <div className="flex flex-col gap-3 bg-gray-50 rounded-lg p-4 text-left">
              {definitions.map((definition) => (
                <p key={definition} className="text-zinc-950 text-sm">
                  {definition}
                </p>
              ))}
            </div>
          )}
        </div>
      )}
    </fieldset>
  );
}
